export default {
  recommendations: "Рекомендации",
  search: "Поиск...",
  searchError: "Пользователь не найден",
  continue: "Продолжить",
  follow: "Подписаться",
  unfollow: "Отписаться",
  exit: "Выйти",
  download: "Скачать мобильное приложение",
  postNotFound: "Пост не найден",
  justNow: "только что",
  feed: {
    lenta: "Лента",
    type: {
      title: "Тип ленты",
      default: "Стандартный",
      short: "Уменьшенный",
    },
    feedEmpty: "Чтобы просматривать посты, подпишитесь на кого-нибудь.",
    error:
      "Произошла ошибка при загрузке ленты. Пожалуйста, повторите попытку позже.",
    remakes: {
      title: "Ремейки",
      description: "Все созданные ремейки будут отображаться здесь",
    },
  },
  menu: {
    home: "Главная",
    profile: "Профиль",
  },
  qr: {
    title: "Мобильное приложение COMIXON",
    description: "Наведите камеру вашего устройства на QR-код",
  },
  comments: {
    title: "Комментарии",
    notFound: "Комментарии не найдены",
    empty: "Комментарий пустой.",
    longError:
      "Комментарий слишком длинный. Максимальная длина - 1024 символа.",
    filter: {
      new: "Новые",
      author: "Автор",
      my: "Мои",
    },
    input: "Введите комментарий",
    active: {
      answer: "Упомянуть",
      remove: "Удалить",
      report: "Жалоба",
    },
    delete: {
      title: "Подтверждение удаления",
      description: "Вы уверены, что хотите удалить этот комментарий?",
      confirm: "Подтвердить",
      close: "Закрыть",
    },
  },
  report: {
    title: "Жалоба",
    category: {},
    send: "Отправить",
    error: "Не удалось отправить жалобу. Пожалуйста, повторите попытку позже.",
  },
  profile: {
    followers: "Подписчики",
    following: "Подписки",
    edit: "Редактировать",
    strip: "Стрипы",
    emptyProfile: "Стрипы пользователя будут здесь",
  },
  profileEdit: {
    title: "Редактирование профиля",
    bg: "Изменить фон",
    colorTitle: "Выбор цвета",
    bubbleType: "Тип бабла",
    formPlaceholder: {
      name: "Имя",
      nickname: "Nickname",
    },
    settings: {
      title: "Настройки профиля",
      description: "Изменить личную информацию",
      error: "Неправильно введенные поля: ",
      inputs: {
        number: {
          label: "Номер телефона",
          placeholder: "Добавить номер телефона",
        },
        email: {
          label: "Почта",
          placeholder: "Добавить электронную почту",
        },
        social: {
          label: "Соц. сети",
          placeholder: "Добавить ссылку на социальную сеть",
        },
        date: { label: "Дата рождения", placeholder: "Добавить дату рождения" },
        city: { label: "Город", placeholder: "Добавить город" },
        region: { label: "Регион" },
      },
    },
    button: "Сохранить",
    save: "Сохранить",
  },
  login: {
    profile: "Войти",
    title: "Войти в учетную запись",
    description: "Введите номер телефона, который вы указали при регистрации",
    bottom:
      "Нажав 'Продолжить', вы принимаете пользовательское соглашение и политику конфиденциальности.",
    error: "Ошибка: ",
    validateError: "Ошибка валидации. ",
    incorrectPhone: "Некорректный номер телефона",
    phoneEmpty: "Введите номер телефона",
    authError: "Ошибка авторизации: ",
  },
  verification: {
    title: "Код подтверждения",
    placeholder: "Введите код",
    description:
      "Введите последние 4 цифры номера, с которого будет выполнен звонок",
    code: "Код может быть отправлен повторно через:",
    codeSms: "Получите код по sms",
    bottom:
      "Нажав 'Подтвердить', вы принимаете пользовательское соглашение и политику конфиденциальности.",
  },
  notification: {
    copy: "Ссылка скопирована в буфер обмена!",
    complain: "Жалоба отправлена",
    openApp: "Открыть в приложении App Store",
    open: "Открыть",
  },
};
